module.exports = __webpack_public_path__ + "img/gaming.aab090cc.svg";